module.exports = __webpack_public_path__ + "img/qualityPlatform_数据时效性强.06aa9769.png";